"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facts_1 = require("../../../types/facts/Facts");
const Facts_2 = require("../../../types/sports/rugbyUnion/Facts");
exports.rugbyUnionFacts = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Facts_2.RugbyUnionSpecificFact), Facts_1.SubstitutionFact), Facts_1.BreakFact), Facts_1.PeriodFact), Facts_1.ClockFact);
exports.rugbyUnionFactNameMap = {
    TRY: 'try',
    TRY_ASSIST: 'try assist',
    CONVERSION: 'conversion success',
    CONVERSION_MISSED: 'conversion missed',
    PENALTY_GOAL: 'penalty goal scored',
    PENALTY_GOAL_MISSED: 'penalty goal missed',
    PENALTY_TRY: 'penalty try',
    DROP_GOAL: 'drop goal scored',
    DROP_GOAL_MISSED: 'drop goal missed',
    KICKING_COMP_GOALS: 'kicking comp goals',
    KICKING_COMP_GOALS_MISSED: 'kicking comp goals missed',
    YELLOW_CARD: 'yellow card',
    RED_CARD: 'red card',
    LINEOUT: 'lineout won',
    LINEOUT_CONCEDED: 'lineout lost',
    SCRUM: 'scrum won',
    SCRUM_CONCEDED: 'scrum lost',
    CLEAN_BREAK: 'clean break',
    DEFENDER_BEATEN: 'defender beaten',
    PENALTY_CONCEDED: 'penalty conceded',
    TURNOVER_CONCEDED: 'turnover conceded',
    RUCK: 'ruck won',
    RUCK_CONCEDED: 'ruck lost',
    RESTART: 'restart',
    FREE_KICK: 'free kick',
    KICK: 'kick'
};
exports.rugbyUnionStatKeyToNameMap = {
    points: 'Points',
    tries: 'Tries',
    tryAssists: 'Try Assists',
    conversions: 'Conversions',
    conversionsMissed: 'Conversions Missed',
    penaltyGoals: 'Penalty Goals',
    penaltyTries: 'Penalty tries',
    penaltyGoalsMissed: 'Penalty Goals Missed',
    dropGoals: 'Drop Goals',
    dropGoalsMissed: 'Drop Goals Missed',
    redCards: 'Red Cards',
    yellowCards: 'Yellow Cards',
    penaltiesConceded: 'Penalties Conceded',
    turnoversConceded: 'Turnovers Conceded',
    scrums: 'Scrums',
    scrumsConceded: 'Scrums Conceded',
    lineouts: 'Lineouts',
    lineoutsConceded: 'Lineouts Conceded',
    rucks: 'Rucks',
    rucksConceded: 'Rucks Conceded',
    restarts: 'Restarts',
    freeKicks: 'Free Kicks',
    kickCompGoals: 'Kick Comp Goals',
    kickCompGoalsMissed: 'Kick Comp Goals Missed',
    kicks: 'Kicks',
    cleanBreaks: 'Clean Breaks',
    defenderBeatens: 'Defender Beaten',
    substitutions: 'Substitutions',
    possession: 'Possession'
};
// tslint:disable-next-line variable-name
exports.RugbyUnionFactStatMap = {
    [Facts_2.RugbyUnionSpecificFact.TRY]: 'tries',
    [Facts_2.RugbyUnionSpecificFact.TRY_ASSIST]: 'tryAssists',
    [Facts_2.RugbyUnionSpecificFact.CONVERSION]: 'conversions',
    [Facts_2.RugbyUnionSpecificFact.CONVERSION_MISSED]: 'conversionsMissed',
    [Facts_2.RugbyUnionSpecificFact.PENALTY_GOAL]: 'penaltyGoals',
    [Facts_2.RugbyUnionSpecificFact.PENALTY_GOAL_MISSED]: 'penaltyGoalsMissed',
    [Facts_2.RugbyUnionSpecificFact.PENALTY_TRY]: 'penaltyTries',
    [Facts_2.RugbyUnionSpecificFact.DROP_GOAL]: 'dropGoals',
    [Facts_2.RugbyUnionSpecificFact.DROP_GOAL_MISSED]: 'dropGoalsMissed',
    [Facts_2.RugbyUnionSpecificFact.KICKING_COMP_GOALS]: 'kickCompGoals',
    [Facts_2.RugbyUnionSpecificFact.KICKING_COMP_GOALS_MISSED]: 'kickCompGoalsMissed',
    [Facts_2.RugbyUnionSpecificFact.YELLOW_CARD]: 'yellowCards',
    [Facts_2.RugbyUnionSpecificFact.RED_CARD]: 'redCards',
    [Facts_2.RugbyUnionSpecificFact.LINEOUT]: 'lineouts',
    [Facts_2.RugbyUnionSpecificFact.LINEOUT_CONCEDED]: 'lineoutsConceded',
    [Facts_2.RugbyUnionSpecificFact.SCRUM]: 'scrums',
    [Facts_2.RugbyUnionSpecificFact.SCRUM_CONCEDED]: 'scrumsConceded',
    [Facts_2.RugbyUnionSpecificFact.CLEAN_BREAK]: 'cleanBreaks',
    [Facts_2.RugbyUnionSpecificFact.DEFENDER_BEATEN]: 'defenderBeatens',
    [Facts_2.RugbyUnionSpecificFact.PENALTY_CONCEDED]: 'penaltiesConceded',
    [Facts_2.RugbyUnionSpecificFact.TURNOVER_CONCEDED]: 'turnoversConceded',
    [Facts_2.RugbyUnionSpecificFact.RUCK]: 'rucks',
    [Facts_2.RugbyUnionSpecificFact.RUCK_CONCEDED]: 'rucksConceded',
    [Facts_2.RugbyUnionSpecificFact.RESTART]: 'restarts',
    [Facts_2.RugbyUnionSpecificFact.FREE_KICK]: 'freeKicks',
    [Facts_2.RugbyUnionSpecificFact.KICK]: 'kicks',
    [Facts_1.SubstitutionFact.SUBSTITUTION]: 'substitutions'
};
//# sourceMappingURL=Facts.js.map